// import JS files
import '../kickstart';
import './countdown';

import { h, render } from 'preact';
import App from '../locator';
import Contest from '../components/Contest';
import CandidateRow from '../components/CandidateRow';
import loadJsonScript from '../utils/load-json-script';

const ballot = loadJsonScript('ballot_data');

const notes = loadJsonScript('notes_data');

const slugify = contest => {
  return contest
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

render(<App />, document.getElementById('app'));

const just_statewide = ballot.filter(
  office =>
    (office.office_type == 'Federal' && office.office != 'U.S. House') ||
    office.office_type == 'Statewide'
);

const statewide_offices_slugged = Array.from(
  new Set(just_statewide.map(number => number.office_name))
).map(id => {
  return {
    name: id,
    slug: slugify(id),
  };
});

statewide_offices_slugged.forEach(element => {
  var each_office = just_statewide.filter(
    item => item.office_name === element.name
  );

  var each_note = notes.filter(item => item.type === element.slug);

  const visibleCandidateCount = 4;

  render(
    <Contest
      ballot={each_office}
      notes={each_note[0]}
      statewideRace
      visibleCandidateCount={visibleCandidateCount}
      renderCandidate={(candidate, idx, viewAllCandidates) => (
        <CandidateRow
          partyName={candidate.party}
          candidate={candidate}
          ballotName={candidate.candidate_name}
          isIncumbent={candidate.incumbent}
          isDropout={candidate.drop_out}
          isViewable={viewAllCandidates || idx < visibleCandidateCount}
        />
      )}
    />,
    document.getElementById('statewide__contests')
  );
});
